import { FC, SVGAttributes } from "react";

const Refresh: FC<SVGAttributes<SVGSVGElement>> = ({
  stroke = "currentColor",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M14.0007 6.66667C14.0007 6.66667 12.664 4.84548 11.5781 3.75883C10.4922 2.67218 8.99159 2 7.33398 2C4.02028 2 1.33398 4.68629 1.33398 8C1.33398 11.3137 4.02028 14 7.33398 14C10.0694 14 12.3772 12.1695 13.0995 9.66667M14.0007 6.66667V2.66667M14.0007 6.66667H10.0007"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export { Refresh };
